<template>
    <div style="display: inline-block;">
        <InputSwitch v-model="text" :disabled="readonly" @click="click" @change="change" />
    </div>
</template>

<script>
import { computed } from 'vue'
import InputSwitch from 'primevue/inputswitch';

export default {
    name: 'tw-switch',
    components: {
        InputSwitch
    },
    emits: {
        click: null,
        change: null
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? '' : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        const click = () => {
            context.emit('click')
        }

        const change = () => {
            context.emit('change')
        }

        return {
            text,
            click,
            change
        }
    },
    props: {
        modelValue: Boolean,
        readonly: Boolean
    }
}
</script>
